import { toggleSelectedModule } from 'actions/moduleSelectionActions';
import { getLocalization } from 'global/global';
import { useAppDispatch, useAppSelector } from 'index';
import { MODULES } from 'Interfaces/ModuleSelectionInterface';
import { KanbanSquare } from 'lucide-react';
import * as React from 'react';
import { Dropdown } from 'react-bootstrap';
import { uniqueFormsSelector } from 'reducers/formsReducer';
import { setSelectedForm } from 'reducers/kanbanMenu';

export default function KanbanMenu() {

  const forms = useAppSelector(state => uniqueFormsSelector(state).filter(f => f.kanban === true));
  const selectedModule = useAppSelector(state => state.moduleSelection.selected);
  const selected = useAppSelector(state => state.kanbanMenu.selectedForm);
  const dispatch = useAppDispatch();

  const onSelect = (ref: string) => {
    dispatch(setSelectedForm(ref));
  };

  if (!forms.length) {
    return null;
  }

  return (
    <Dropdown
      id="chart-btn"
      onToggle={(isOpen, metadata) => {
        if (metadata.source === 'click' && selectedModule !== MODULES.KANBAN) {
          dispatch(toggleSelectedModule(MODULES.KANBAN));
        }
      }}
    >
      <Dropdown.Toggle id="chart-btn-toggle" variant="primary" size={'sm'}>
        <KanbanSquare size={18} />
        <span className={'ms-1'}>{getLocalization('kanban')}</span>
      </Dropdown.Toggle>
      <Dropdown.Menu rootCloseEvent="click" onClick={(e) => e.stopPropagation()}>
        {forms.map((form, index) => (
          <Dropdown.Item
            as="div"
            eventKey={`${index}`}
            key={`table-dropdown-item-${form.ref}`}
            onClick={() => onSelect(form.ref)}
            active={selected === form.ref}
          >
            {form.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
